module.exports = __webpack_public_path__ + "static/assets/5796214a21c5c1727ed7b08096ee7cff.woff2";